import React from "react";
import { Link } from "react-router-dom";
import { POLICY_ADDRESS } from "./PolicyPage";
import "../css/footer.scss";

const customerCareLinks = [
  ["/shipping", "Shipping & Delivery"],
  ["/returns", "Returns & Refunds"],
  ["/orders", "Orders & Cancellation"],
  ["/payments", "Payment & Billing"],
  ["/pricing", "Pricing, Tax & Customs"],
  ["/promotions", "Promotions"],
  ["/product-safety", "Product Information & Safety"],
  ["/warranty", "Warranty & Complaints"],
  ["/faqs", "FAQs"],
  ["/contact", "Contact Us"],
];

const legalLinks = [
  ["/policies", "All Policies"],
  ["/privacy", "Privacy Policy"],
  ["/privacy-choices", "Your Privacy Choices"],
  ["/cookies", "Cookie & Storage Policy"],
  ["/terms", "Terms of Service"],
  ["/acceptable-use", "Acceptable Use"],
  ["/intellectual-property", "Intellectual Property & Rights"],
  ["/reviews-policy", "Reviews & Testimonials"],
  ["/communications", "Electronic Communications"],
  ["/accessibility", "Accessibility"],
  ["/security", "Security Reporting"],
  ["/legal-notice", "Legal Notice"],
];

function FooterLinks({ links, toTop }) {
  return (
    <nav className="footer-nav">
      {links.map(([to, label]) => (
        <Link to={to} onClick={toTop} className="footer-link" key={to}>
          {label}
        </Link>
      ))}
    </nav>
  );
}

function Footer() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-section support">
            <h3 className="footer-title">Customer Care</h3>
            <FooterLinks links={customerCareLinks} toTop={toTop} />
          </div>

          <div className="footer-section support">
            <h3 className="footer-title">Legal &amp; Privacy</h3>
            <FooterLinks links={legalLinks} toTop={toTop} />
          </div>

          <div className="footer-section newsletter">
            <h3 className="footer-title">slayfulpawsco</h3>
            <p className="newsletter-description">
              <a href="mailto:phase@slayfulpawsco.cloud">
                phase@slayfulpawsco.cloud
              </a>
              <br />
              {POLICY_ADDRESS}
            </p>

            <Link to="/policies" onClick={toTop} className="footer-link">
              Visit the Policy Center
            </Link>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>Copyright © {currentYear}, slayfulpawsco</p>
          </div>

          <div
            className="payment-methods"
            aria-label="Payment options confirmed at checkout"
          />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
